<template>
  <div class="l-header">
    <div class="header" :class="{'header--transparent': isTransparent}">
      <div class="header__content l-page-content">
        <section>
          <router-link
            to="/"
          >
            <img src="@/assets/images/logo.png" alt="">
          </router-link>
        </section>

        <section
          class="header__nav mobile-hide1"
          :class="{'header__nav--active': isNavActive}">
          <router-link
            to="/partner-info"
            class="header__nav-link"
            active-class="header__nav-link--active"
          >
            Партнерам
          </router-link>

          <router-link
            :to="{ name: 'sign-in' }"
            class="header__nav-link">
            Вход
          </router-link>
        </section>

        <section class="header__menu-btn header__right mobile-only">
          <i class="o-icon-menu" @click="toggleNav" />
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isTransparent: true,
      // for mobile only
      isNavActive: false,
    };
  },
  methods: {
    toggleNav() {
      this.isNavActive = !this.isNavActive;
    },
    handleResize() {
      this.isNavActive = false;
    },
    handleScroll() {
      if (window.scrollY >= 30) {
        this.isTransparent = false;
      } else {
        this.isTransparent = true;
      }
    },
  },
  watch: {
    isNavActive(val) {
      if (val) {
        document.body.style.overflow = 'hidden';
        window.addEventListener('resize', this.handleResize);
      } else {
        document.body.style.overflow = '';
        window.removeEventListener('resize', this.handleResize);
      }
    },
  },
  created() {
    this.handleResize = this.handleResize.bind(this);

    window.onscroll = this.handleScroll;
  },
};
</script>

<style lang="scss">
.l-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1001;
}

.header {
  background: #08021f;
  transition: background .7s ease-in-out;

  &__content {
    display: flex;
    align-items: center;
    height: 80px;
    font-size: 1.125rem;
    color: #fefefe;
    transform: none;
    z-index: inherit;
    box-sizing: border-box;

  }

  &--transparent {
    background: transparent;
  }

  &__menu-btn {
    margin-left: auto;
    margin-right: 2rem;
    z-index: 900;
  }

  &__nav {
    display: flex;
    height: 100%;
    align-items: center;
    margin-left: auto;
    margin-right: 2rem;

    @include device-until(tablet) {
      display: none;
      background: rgba(0,0,0,.9);
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: 0;
      z-index: 5;
      padding: 1.25rem 1.5625rem;
      overflow: auto;
      box-sizing: border-box;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;

      &--active {
        display: block;
      }
    }
  }

  &__nav-link {
    display: flex;
    height: 100%;
    align-items: center;
    font-size: 1.125rem;
    font-weight: 600;
    color: inherit;
    text-decoration: none;
    margin-left: 2rem;
    box-sizing: border-box;

    @include device-until(tablet) {
      height: auto;
      margin: 1rem 0;
      font-size: 1.5rem;
      justify-content: center;
    }

    &--active {
      color: #ff61a1;
      position: relative;

      &::after {
        content: '';
        display: block;
        position: absolute;
        width: 100%;
        bottom: 0;
        border-bottom: 4px solid #ff61a1;

        @include device-until(tablet) {
          border-bottom: none;
        }
      }
    }
  }
}
</style>
